import type {MutableRefObject} from 'react';

export function isRefObject<T>(
    ref: ((instance: T | null) => void) | MutableRefObject<T | null> | null,
): ref is MutableRefObject<T> {
    return (ref as MutableRefObject<T>)?.current !== undefined;
}
